import Cookies from 'js-cookie';

// export const COOKIE_APP_TKN = 'ZION-APP-TKN';
// export const COOKIE_USR_TKN = 'ZION-USR-TKN';
// export const COOKIE_USR_ID = 'ZION-USR-ID';
export const COOKIE_DAYS_TO_EXPIRE = 20;

export const writeOnCookie = (cookieName, value) => {
  return Cookies.set(cookieName, value, {
    expires: COOKIE_DAYS_TO_EXPIRE,
    sameSite: 'strict',
    secure: true,
  });
};

export const getFromCookie = cookieName => {
  return Cookies.get(cookieName);
};

export const removeFromCookie = cookieName => {
  return Cookies.remove(cookieName, {
    expires: COOKIE_DAYS_TO_EXPIRE,
    sameSite: 'strict',
    secure: true,
  });
};
